import React from "react"

/**
 * Próximas provas do roteiro (ESA → EEAR → EsPCEx → AFA). A EEAR saiu daqui ao
 * entrar no ar: prova jogável é listada em "suas provas", não prometida aqui —
 * aparecer nos dois lugares ao mesmo tempo confunde.
 */
const PROXIMAS: { sigla: string; ramo: string }[] = [
  { sigla: "EsPCEx", ramo: "Exército" },
  { sigla: "AFA", ramo: "Aeronáutica" },
  { sigla: "Colégio Naval", ramo: "Marinha" },
]

/**
 * Vitrine "em breve" — mostra que o candidato não fica preso à ESA: o plano
 * vale em qualquer prova que lançarmos. Caixas cinzas/desabilitadas
 * de propósito, pra sinalizar futuro sem prometer data.
 */
export function ComingSoonProvas() {
  return (
    <div className="mt-4">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-navy-400">Em breve, mais provas</p>

      <div className="grid grid-cols-3 gap-2.5 sm:gap-4">
        {PROXIMAS.map((p) => (
          <div
            key={p.sigla}
            aria-disabled="true"
            className="relative flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-2 py-5 text-center"
          >
            <span className="absolute right-2 top-2 rounded-full bg-slate-200 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-slate-500">
              em breve
            </span>
            <p className="font-display text-base font-bold uppercase tracking-wide text-navy-400 sm:text-2xl">{p.sigla}</p>
            <p className="mt-0.5 text-[10px] uppercase tracking-wide text-slate-400 sm:text-[11px]">{p.ramo}</p>
          </div>
        ))}
      </div>

      <p className="mt-2.5 flex items-center justify-center gap-1.5 text-center text-xs text-navy-500">
        <svg viewBox="0 0 20 20" fill="currentColor" className="h-3.5 w-3.5 shrink-0 text-gold-500" aria-hidden="true">
          <path
            fillRule="evenodd"
            d="M10 1a4.5 4.5 0 00-4.5 4.5V8H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm2.5 7V5.5a2.5 2.5 0 00-5 0V8h5z"
            clipRule="evenodd"
          />
        </svg>
        Seu plano vale em qualquer prova nova — o acesso não fica preso à ESA.
      </p>
    </div>
  )
}
